<div class="date-diff-card">

  <h2>Date Difference Calculator</h2>
  <p class="subtitle">Find the exact difference between two dates</p>

  <div class="inputs row">
    <div class="col-12 col-md-6">
      <label for="start">Start Date</label>
      <input
        id="start"
        type="date"
        class="form-control"
        placeholder="DD-MM-YYYY"
        (change)="onStartChange($event)"
      />
    </div>

    <div class="col-12 col-md-6">
      <label for="end">End Date</label>
      <input
        id="end"
        type="date"
        class="form-control"
        placeholder="DD-MM-YYYY"
        (change)="onEndChange($event)"
      />
    </div>
  </div>

  @if (difference(); as d) {
  <div class="result">
    <div class="row">
      <strong>{{ d.years }} years, {{ d.months }} months, {{ d.days }} days
      </strong>
    </div>
  </div>
}
</div>
